import { useState } from 'react';
// import httpClient from '../../../../services/http';
// import { APIUtils } from '../../../../utils/apiutils';
import { fbOtpHandler } from '../../../../config/firebase.config';
import Swal from 'sweetalert2';

const useReqGenOtp = () => {
    const [loading, setLoading] = useState(false);

    // const generateOtp = async ({reqId, reqFor}) => {
    //     setLoading(true);
    //     const payload = { reqId, reqFor };
    //     const url = APIUtils.getAdminAPIEndpoint('req-gen-otp');
    //     const {err, res} = await httpClient.post(url, payload).then(res => ({err: null, res: res.data})).catch(err => ({err, res: null}));
    //     setLoading(false);
    //     return { err, res };
    // };

    const requestOtp = async ({phoneNumber, captchaElementOrID}) => {
        console.log({captchaElementOrID});
        setLoading(true);
        const { err, res } = await fbOtpHandler.sendFbOtp({phoneNumber, captchaElementOrID});
        setLoading(false);
        if (err) {
            if (err?.code && err.code === 'auth/too-many-requests') {
                Swal.fire('Sorry!', 'Exceeded the allowed number of OTP requests for a the phone number. Please, try again after 1hr.', 'error');
            }
        }
        return { err, res };
    };

    return { loading, requestOtp };
};

export default useReqGenOtp;